import React, { Component } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { translate } from 'react-polyglot';
import rtl from '../RTLProvider/rtl';

import './ErrorPage.scss';

@rtl
class ErrorPage extends Component {
  static defaultProps = {
    image: "https://storage.googleapis.com/story-weaver-e2e-production/illustrations/2201/large/Cover_Illustration.jpg?1444749143"
  }

  render() {
    const baseClassName = 'pb-error-page';
    const { showErrorText, t } = this.props;

    const styles = {};
    if (showErrorText) {
      styles.backgroundImage = `url('${this.props.image}')`;
    } else {
      styles.backgroundImage = `url('../../500_error.png')`;
    }
    const classes = {
      [baseClassName]: true,
      [`${baseClassName}--rtl`]: this.props.isRtl
    }

    return (
      <div className={classNames(classes)}>
        <div className={`${baseClassName}__image-wrapper`} style={styles}>
        </div>
        <div className={`${baseClassName}__error-txt`}>
            <p className={`${baseClassName}__header`}>{showErrorText ? t('global.404-error-header') : t('global.500-error-header')} </p>
            <h1 className={`${baseClassName}__title`}>{showErrorText ? t('global.404-error') : t('global.500-error')}</h1>
            <p className={`${baseClassName}__content`}>{showErrorText ? t('global.404-error-description') : t('global.500-error-description')} </p>
        </div>
      </div>
    );
  }
}

ErrorPage.propTypes = {
  title: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired
};
export default translate()(ErrorPage);



// WEBPACK FOOTER //
// ./src/components/ErrorPage/ErrorPage.jsx